import { useCallback, forwardRef, useImperativeHandle, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { PresentUrl, idverificationanotherApi, basicFormApi, aadharsendOtpToNumberApi, SubmitOTPAADHARVERIFIEDApi, denaveAadharFetchApi, denaveAadharOtpApi, denaveAadharVerifyApi, basicFormStateCityApi, denaveStateGetApi } from "../../../text/apidata.js";
import ImageCropper from "../ReactcropOverall/Imagecrop.js";
import { store } from "../../../Redux/Store.js";
import { responsiveToast } from "../../AppComponent/responsiveToast.js";
import {
  removeBasicImage,
  selectEmployeeInformation,
  setBasicImage,
  updateBasicField,
} from "../../../Redux/employeeInformationSlice.js";
import { getLoaderAction2 } from "../../../Redux/Loader2.js";
import styles from "./BasicInformation.module.scss";

const formatDateForInput = (dobStr) => {
  if (!dobStr) return "";
  const str = String(dobStr).trim();
  if (str.includes("-")) {
    const parts = str.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 2 && parts[2].length === 4) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
      } else if (parts[0].length === 4) {
        return str;
      }
    }
  }
  if (str.includes("/")) {
    const parts = str.split("/");
    if (parts.length === 3) {
      if (parts[0].length === 2 && parts[2].length === 4) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
      } else if (parts[0].length === 4) {
        return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
      }
    }
  }
  return str;
};

const isValidDateOfBirth = (dob) => {
  if (!dob) return false;
  const str = String(dob).trim();
  if (
    str.includes("undefined") ||
    str.includes("null") ||
    str.includes("NaN")
  ) {
    return false;
  }
  // Reject 4-digit year only e.g. "2002"
  if (/^\d{4}$/.test(str)) {
    return false;
  }

  let y, m, d;
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(str)) {
    const parts = str.split("-");
    y = parseInt(parts[0], 10);
    m = parseInt(parts[1], 10);
    d = parseInt(parts[2], 10);
  } else if (/^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(str)) {
    const parts = str.split(/[\/-]/);
    d = parseInt(parts[0], 10);
    m = parseInt(parts[1], 10);
    y = parseInt(parts[2], 10);
  } else {
    const parsedDate = new Date(str);
    if (isNaN(parsedDate.getTime())) return false;
    y = parsedDate.getFullYear();
    m = parsedDate.getMonth() + 1;
    d = parsedDate.getDate();
  }

  const currentYear = new Date().getFullYear();
  if (y < 1920 || y > currentYear || m < 1 || m > 12 || d < 1 || d > 31) {
    return false;
  }

  return true;
};

const formatDateOfBirth = (dob) => {
  if (!dob) return "";
  const str = String(dob).trim();
  if (
    str.includes("undefined") ||
    str.includes("null") ||
    str.includes("NaN")
  ) {
    return "";
  }
  // Reject 4-digit year only e.g. "2002"
  if (/^\d{4}$/.test(str)) {
    return "";
  }

  // YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const parts = str.split("-");
    const y = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const d = parseInt(parts[2], 10);
    const currentYear = new Date().getFullYear();
    if (y < 1920 || y > currentYear || m < 1 || m > 12 || d < 1 || d > 31) return "";
    return str;
  }

  // DD/MM/YYYY or DD-MM-YYYY
  if (/^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(str)) {
    const parts = str.split(/[\/-]/);
    const day = parts[0].padStart(2, "0");
    const month = parts[1].padStart(2, "0");
    const year = parts[2];
    const y = parseInt(year, 10);
    const m = parseInt(month, 10);
    const d = parseInt(day, 10);
    const currentYear = new Date().getFullYear();
    if (y < 1920 || y > currentYear || m < 1 || m > 12 || d < 1 || d > 31) return "";
    return `${year}-${month}-${day}`;
  }

  // YYYY-M-D
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(str)) {
    const parts = str.split("-");
    const year = parts[0];
    const month = parts[1].padStart(2, "0");
    const day = parts[2].padStart(2, "0");
    const y = parseInt(year, 10);
    const m = parseInt(month, 10);
    const d = parseInt(day, 10);
    const currentYear = new Date().getFullYear();
    if (y < 1920 || y > currentYear || m < 1 || m > 12 || d < 1 || d > 31) return "";
    return `${year}-${month}-${day}`;
  }

  return isValidDateOfBirth(str) ? str : "";
};

const calculateAge = (dobString) => {
  if (!dobString) return "";
  let birthDate = null;
  const str = String(dobString).trim();

  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(str)) {
    const parts = str.split("-").map(Number);
    birthDate = new Date(parts[0], parts[1] - 1, parts[2]);
  } else if (/^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(str)) {
    const parts = str.split(/[\/-]/).map(Number);
    birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
  } else {
    const parsed = new Date(str);
    if (!isNaN(parsed.getTime())) {
      birthDate = parsed;
    }
  }

  if (!birthDate || isNaN(birthDate.getTime())) return "";

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age >= 0 ? String(age) : "";
};

const formatGender = (g) => {
  if (!g) return "";
  const str = String(g).trim().toLowerCase();
  if (str === "m" || str === "male") return "Male";
  if (str === "f" || str === "female") return "Female";
  if (str === "other" || str === "o") return "Other";
  return g.charAt(0).toUpperCase() + g.slice(1);
};

const formatBloodGroup = (bg) => {
  if (!bg || bg === "Select" || bg === "select") return "";
  let clean = String(bg).trim();
  clean = clean
    .replace(/POSITIVE/gi, "+")
    .replace(/NEGATIVE/gi, "-")
    .replace(/\s*\+VE/gi, "+")
    .replace(/\s*-VE/gi, "-")
    .replace(/\s+/g, "");

  const upper = clean.toUpperCase();
  if (upper === "A+") return "A+";
  if (upper === "A-") return "A-";
  if (upper === "B+") return "B+";
  if (upper === "B-") return "B-";
  if (upper === "O+") return "O+";
  if (upper === "O-") return "O-";
  if (upper === "AB+") return "AB+";
  if (upper === "AB-") return "AB-";
  if (upper === "RH+") return "Rh+";
  if (upper === "RH-") return "Rh-";
  if (upper === "A1+") return "A1+";
  if (upper === "A1-") return "A1-";
  if (upper === "B1+") return "B1+";
  if (upper === "B1-") return "B1-";
  if (upper === "A1B+") return "A1B+";
  if (upper === "A1B-") return "A1B-";

  return clean;
};

const selectOptions = {
  bloodGroup: [
    "Select",
    "A+",
    "A-",
    "B+",
    "B-",
    "O+",
    "O-",
    "AB+",
    "AB-",
  ],
  religion: [
    "Select",
    "Christian",
    "Hindu",
    "Muslim",
    "Jain",
    "Buddhist",
    "OTHER",
  ],
  employmentType: [
    { label: "Select", value: "" },
    { label: "Permanent", value: "0" },
    { label: "Contractual", value: "1" },
    { label: "Consultant", value: "2" },
    { label: "Freelancer", value: "3" },
    { label: "Intern", value: "4" },
    { label: "Apprentice", value: "5" },
  ],
  employeeCategory: [
    { label: "Select", value: "" },
    { label: "FOS", value: "0" },
    { label: "Non FOS", value: "1" },
    { label: "Non FOS - Tele", value: "2" },
    { label: "Apprentice", value: "3" },
  ],
};

const inputFields = [
  { name: "first_name", label: "Name", required: true },
  { name: "phoneNum", label: "Phone Number", required: true },
  {
    name: "emergency_contact_number",
    label: "Emergency Contact",
    required: true,
  },
  { name: "email_id", label: "Email" },
  {
    name: "DateofBirth",
    label: "Date of Birth",
    required: true,
    type: "date",
  },
  { name: "age", label: "Age" },
  { name: "placeofBirth", label: "Place Of Birth" },
];

const requiredFields = [
  { name: "aadhar_number", label: "Aadhaar Number" },
  { name: "first_name", label: "Name" },
  { name: "phoneNum", label: "Phone Number" },
  {
    name: "emergency_contact_number",
    label: "Emergency Contact",
  },
  { name: "DateofBirth", label: "Date of Birth" },
  { name: "blood_group", label: "Blood Group" },
  { name: "religion", label: "Religion" },
  // { name: "employee_type", label: "Employement Type" },
  // { name: "employee_category", label: "Employee Catergory" },
  // { name: "state", label: "State" },
  // { name: "city", label: "City" },
];

const BasicInformation = forwardRef(function BasicInformation(_, ref) {
  const dispatch = useDispatch();
  const { basicInformation: form, basicImages: images } = useSelector(
    selectEmployeeInformation,
  );

  const selfonboardData = useSelector(
    (state) => state.selfonboardingretriveslice?.Selfonboarding_Data
  );
  const employeeDetails = useSelector(
    (state) =>
      state.Signature_Employee_RetrieveCall_actions?.Signature_Employee_Datas
  );

  const [errorFields, setErrorFields] = useState(new Set());
  const [cropperOpen, setCropperOpen] = useState(false);
  const [cropperTargetName, setCropperTargetName] = useState("");
  const [selectedImageEvent, setSelectedImageEvent] = useState(null);

  const [denaveStateList, setDenaveStateList] = useState([]);
  const [denaveCityList, setDenaveCityList] = useState([]);

  // Aadhaar Verification States (UIDAI vs Manual)
  const [verificationMode, setVerificationMode] = useState("Manual");
  const [sendingOtp, setSendingOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpValue, setOtpValue] = useState("");
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [otpMessage, setOtpMessage] = useState("");

  const [initialFields, setInitialFields] = useState({
    aadhar_number: false,
    first_name: false,
    phoneNum: false,
    email_id: false,
    gender: false,
  });

  const fetchedBasicFormIdRef = useRef(null);
  const extractedOcrDataRef = useRef(null);

  const extractClientIdFromDetails = (d) => {
    if (!d) return "";
    const raw =
      d?.client_id?.id ||
      d?.client_id ||
      d?.employeetimeline_id?.client_id ||
      d?.client;

    if (typeof raw === "object" && raw !== null) {
      return raw.id || raw._id || "";
    }
    return String(raw || "");
  };

  useEffect(() => {
    const details = selfonboardData || employeeDetails;
    if (!details) return;

    const initialCheck = {
      aadhar_number: Boolean(
        form.aadhar_number ||
        details?.aadhar_number ||
        details?.aadhaar_number ||
        details?.basicform_id?.aadhar_number ||
        details?.basic_form?.aadhar_number
      ),
      first_name: Boolean(
        form.first_name ||
        details?.first_name ||
        details?.name ||
        details?.basicform_id?.first_name ||
        details?.basic_form?.first_name
      ),
      phoneNum: Boolean(
        form.phoneNum ||
        details?.phone_number ||
        details?.phoneNum ||
        details?.basicform_id?.phone_number ||
        details?.basic_form?.phone_number
      ),
      email_id: Boolean(
        form.email_id ||
        details?.email_id ||
        details?.email ||
        details?.basicform_id?.email_id ||
        details?.basic_form?.email_id
      ),
      gender: Boolean(
        form.gender ||
        details?.gender ||
        details?.basicform_id?.gender ||
        details?.basic_form?.gender
      ),
    };

    setInitialFields((prev) => {
      const updated = { ...prev };
      let changed = false;
      Object.keys(initialCheck).forEach((key) => {
        if (initialCheck[key] && !prev[key]) {
          updated[key] = true;
          changed = true;
        }
      });
      return changed ? updated : prev;
    });

    const extractBasicFormId = (d) => {
      if (!d) return null;
      const raw =
        d?.employeetimeline_id?.basic_info ||
        d?.employeetimeline_id?.basic_details ||
        d?.employeetimeline_id?.basic_info_form ||
        d?.basicform_id ||
        d?.basic_form_id ||
        d?.basicform ||
        d?.basic_form ||
        d?.basic_info_id ||
        d?.basic_info;

      if (!raw) return null;
      if (typeof raw === "object" && raw !== null) {
        return raw.id || raw.basicform_id || raw.basic_form_id || raw._id || null;
      }
      return String(raw);
    };

    const basicformId = extractBasicFormId(details);

    if (basicformId) {
      const sessionToken =
        details?.session_token || details?.token || details?.sessionToken;
      const headers = sessionToken
        ? {
          Authorization: String(sessionToken).startsWith("Bearer ")
            ? sessionToken
            : `Bearer ${sessionToken}`,
        }
        : {};

      dispatch(getLoaderAction2(true));
      axios
        .get(`${basicFormApi}${basicformId}/`, { headers })
        .then((res) => {
          console.log("Basic form GET API response:", res.data);
          const data = res.data?.data || res.data;
          if (data) {
            const identificationMark = Array.isArray(
              data?.personal_identification_mark
            )
              ? data.personal_identification_mark[0] || ""
              : data?.personal_identification_mark || "";

            const financeData = Array.isArray(data?.finance_data)
              ? data.finance_data[0]
              : data?.finance_data || {};

            const aadharFrontCount =
              financeData?.aadhar_front_count !== undefined
                ? Number(financeData.aadhar_front_count)
                : data?.aadhar_front_count !== undefined
                  ? Number(data.aadhar_front_count)
                  : 0;

            const aadharCount =
              financeData?.aadhar_count !== undefined
                ? Number(financeData.aadhar_count)
                : data?.aadhar_count !== undefined
                  ? Number(data.aadhar_count)
                  : 0;

              const dobVal = formatDateOfBirth(data?.date_of_birth || data?.DateofBirth);
              const computedAge = data?.age || calculateAge(dobVal);

              const basicFieldMap = {
                first_name: data?.first_name || data?.name || "",
                phoneNum: data?.phone_number || data?.phoneNum || "",
                emergency_contact_number:
                  data?.emergency_contact_number || "",
                email_id: data?.email_id || data?.email || "",
                aadhar_number: data?.aadhar_number || data?.aadhaar_number || "",
                DateofBirth: dobVal,
                placeofBirth: data?.place_of_birth || data?.placeofBirth || "",
                gender: formatGender(data?.gender),
                age: computedAge || "",
              blood_group: formatBloodGroup(data?.blood_group || data?.bloodGroup),
              religion: data?.religion || "",
              personal_identification_mark: identificationMark,
              employee_type: data?.employee_type ?? "",
              employee_category: data?.employee_category ?? "",
              state: data?.state || "",
              city: data?.city || "",
              referral_number: data?.referral_number || "",
              aadhar_front_count: aadharFrontCount,
              aadhar_count: aadharCount,
            };

            setInitialFields((prev) => ({
              aadhar_number: prev.aadhar_number || Boolean(data?.aadhar_number || data?.aadhaar_number),
              first_name: prev.first_name || Boolean(data?.first_name || data?.name),
              phoneNum: prev.phoneNum || Boolean(data?.phone_number || data?.phoneNum),
              email_id: prev.email_id || Boolean(data?.email_id || data?.email),
              gender: prev.gender || Boolean(data?.gender),
            }));

            Object.entries(basicFieldMap).forEach(([name, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                dispatch(updateBasicField({ name, value }));
              }
            });

            const isVerifiedOnServer =
              data?.is_aadhar_verified === true ||
              data?.aadhar_verified === true ||
              data?.is_aadhaar_verified === true ||
              data?.is_aadhar_verified === "true" ||
              data?.aadhar_verified === "true";

            if (isVerifiedOnServer) {
              setIsAadharVerified(true);
              dispatch(updateBasicField({ name: "is_aadhar_verified", value: true }));
              dispatch(updateBasicField({ name: "aadhar_verified", value: true }));
            }

            const aadharFrontObj = data?.aadhar_front;
            const aadharImgUrl =
              typeof aadharFrontObj === "object" && aadharFrontObj !== null
                ? aadharFrontObj.media_url || aadharFrontObj.url
                : aadharFrontObj;

            if (aadharImgUrl) {
              dispatch(
                setBasicImage({
                  name: "aadhaarFront",
                  image: {
                    name: "aadhaarFront",
                    url: aadharImgUrl,
                    s3Url: aadharImgUrl,
                  },
                })
              );
            }

            const userImgObj = data?.user_image;
            const userImgUrl =
              typeof userImgObj === "object" && userImgObj !== null
                ? userImgObj.media_url || userImgObj.url
                : userImgObj;

            if (userImgUrl) {
              dispatch(
                setBasicImage({
                  name: "profile",
                  image: {
                    name: "profile",
                    url: userImgUrl,
                    s3Url: userImgUrl,
                  },
                })
              );
            }
          }
        })
        .catch((err) => {
          console.error("Error fetching basic form GET API:", err);
        })
        .finally(() => {
          dispatch(getLoaderAction2(false));
        });
    }
  }, [dispatch, selfonboardData, employeeDetails]);

  // Fetch State List for Basic Information using basicFormStateCityApi
  useEffect(() => {
    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    axios
      .get(basicFormStateCityApi, {
        headers,
        params: { request_type: "state", country: "India" },
      })
      .then((res) => {
        console.log("basicFormStateCityApi state response:", res.data);
        const rawList =
          res.data?.data?.state ||
          res.data?.state ||
          res.data?.data ||
          res.data?.results ||
          (Array.isArray(res.data) ? res.data : []);

        const states = Array.isArray(rawList)
          ? rawList
            .map((item) =>
              typeof item === "object" && item !== null
                ? item.state || item.name || item.state_name || ""
                : String(item)
            )
            .filter(Boolean)
          : [];

        if (states.length > 0) {
          setDenaveStateList(states);
        }
      })
      .catch((err) => {
        console.error("Error fetching state list from basicFormStateCityApi:", err);
      });
  }, [selfonboardData, employeeDetails]);

  // Fetch City List when state selection changes using basicFormStateCityApi
  useEffect(() => {
    if (!form.state || form.state === "Select") {
      setDenaveCityList([]);
      return;
    }

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    axios
      .get(basicFormStateCityApi, {
        headers,
        params: {
          request_type: "city",
          country: "India",
          state: form.state,
        },
      })
      .then((res) => {
        console.log("basicFormStateCityApi city response:", res.data);
        const rawList =
          res.data?.data?.city ||
          res.data?.city ||
          res.data?.data ||
          res.data?.results ||
          (Array.isArray(res.data) ? res.data : []);

        const cities = Array.isArray(rawList)
          ? rawList
            .map((item) =>
              typeof item === "object" && item !== null
                ? item.city || item.name || item.city_name || ""
                : String(item)
            )
            .filter(Boolean)
          : [];

        if (cities.length > 0) {
          setDenaveCityList(cities);
        }
      })
      .catch((err) => {
        console.error("Error fetching city list from basicFormStateCityApi:", err);
      });
  }, [form.state, selfonboardData, employeeDetails]);

  useEffect(() => {
    if (form.DateofBirth) {
      const computedAge = calculateAge(form.DateofBirth);
      if (computedAge && computedAge !== String(form.age)) {
        dispatch(updateBasicField({ name: "age", value: computedAge }));
      }
    }
  }, [form.DateofBirth, form.age, dispatch]);

  const clearError = (name) => {
    setErrorFields((prev) => {
      const next = new Set(prev);
      next.delete(name);
      return next;
    });
  };

  const updateField = (name, value) => {
    dispatch(updateBasicField({ name, value }));
    clearError(name);
  };

  const updateNumberField = (name, value) => {
    updateField(name, value.replace(/\D/g, ""));
  };

  const handleOtpDigitChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "");
    const newOtp = [...otpDigits];
    newOtp[index] = val.slice(-1);
    setOtpDigits(newOtp);
    const combined = newOtp.join("");
    setOtpValue(combined);

    if (val && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  };

  const handleSendAadhaarOtp = async () => {
    if (!form.aadhar_number || form.aadhar_number.length !== 12) {
      setErrorFields((prev) => new Set([...prev, "aadhar_number"]));
      setOtpMessage("Please enter a valid 12-digit Aadhaar number");
      return;
    }

    setSendingOtp(true);
    setOtpMessage("");

    const currentAadharCount = Number(form.aadhar_count || 0);
    dispatch(updateBasicField({ name: "aadhar_count", value: currentAadharCount + 1 }));

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    try {
      dispatch(getLoaderAction2(true));
      const res = await axios.post(
        denaveAadharOtpApi,
        {
          aadhaarNumber: form.aadhar_number,
        },
        { headers }
      );

      console.log("Send Aadhaar OTP response:", res.data);
      const resData = res.data?.data || res.data;
      const refId =
        resData?.reference_id ||
        resData?.client_id ||
        resData?.data?.reference_id ||
        resData?.data?.client_id ||
        resData?.id;

      if (refId) {
        setReferenceId(String(refId));
      }

      setOtpSent(true);
      setOtpMessage(
        res.data?.message ||
        res.data?.status?.message ||
        resData?.message ||
        "OTP sent successfully to registered mobile number"
      );
    } catch (err) {
      console.error("Send Aadhaar OTP error:", err);
      setOtpMessage(
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.response?.data?.status?.message ||
        "Failed to send OTP. Please check Aadhaar number."
      );
    } finally {
      setSendingOtp(false);
      dispatch(getLoaderAction2(false));
    }
  };

  const handleVerifyAadhaarOtp = async () => {
    if (!otpValue || otpValue.length < 4) {
      setOtpMessage("Please enter a valid OTP");
      return;
    }

    setVerifyingOtp(true);
    setOtpMessage("");

    const details = selfonboardData || employeeDetails;
    const retrieveClientId = extractClientIdFromDetails(details);
    const targetClientId = retrieveClientId || referenceId;

    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    try {
      dispatch(getLoaderAction2(true));
      const res = await axios.post(
        denaveAadharVerifyApi,
        {
          client_id: referenceId,
          otp: otpValue,
        },
        { headers }
      );

      console.log("Verify Aadhaar OTP response:", res.data);
      const outerData = res.data?.data || {};
      const innerData = outerData?.data || outerData;
      const statusMsg = String(res.data?.status?.message || "").toLowerCase();
      const innerMsg = String(innerData?.message || outerData?.message || "").toLowerCase();
      const innerStatus = String(innerData?.status || "").toUpperCase();

      const isVerified =
        innerStatus === "VALID" ||
        innerMsg.includes("card exists") ||

        Boolean(innerData?.name && (innerData?.date_of_birth || innerData?.dob));
      console.log(isVerified, "innerMsginnerMsg", innerData, statusMsg, innerMsg, innerStatus)
      if (isVerified) {
        setIsAadharVerified(true);
        dispatch(updateBasicField({ name: "is_aadhar_verified", value: true }));
        dispatch(updateBasicField({ name: "aadhar_verified", value: true }));
        setOtpSent(true);
        setOtpMessage("Aadhaar verified successfully!");
        responsiveToast("Aadhaar verified successfully!", "success");

        const extracted = innerData;

        if (extracted) {
          if (extracted.name || extracted.first_name) {
            dispatch(
              updateBasicField({
                name: "first_name",
                value: extracted.name || extracted.first_name,
              })
            );
          }
          if (extracted.date_of_birth || extracted.dob) {
            const rawDob = extracted.date_of_birth || extracted.dob;
            dispatch(
              updateBasicField({
                name: "DateofBirth",
                value: formatDateForInput(rawDob),
              })
            );
          }
          if (extracted.gender) {
            dispatch(
              updateBasicField({
                name: "gender",
                value: formatGender(extracted.gender),
              })
            );
          }
          if (
            extracted.full_address ||
            extracted.address ||
            extracted.district ||
            extracted.state ||
            extracted.place_of_birth
          ) {
            const addressVal =
              extracted.full_address ||
              extracted.place_of_birth ||
              (typeof extracted.address === "object" && extracted.address !== null
                ? [extracted.address.house, extracted.address.street, extracted.address.vtc, extracted.address.district, extracted.address.state].filter(Boolean).join(", ")
                : typeof extracted.address === "string"
                  ? extracted.address
                  : "");

            dispatch(
              updateBasicField({
                name: "placeofBirth",
                value: addressVal,
              })
            );
          }
        }
      } else {
        setIsAadharVerified(false);
        setOtpSent(true);
        const errMsg = "Invalid OTP. Please try again.";
        setOtpMessage(errMsg);
        responsiveToast(errMsg, "error");
        return;
      }
    } catch (err) {
      console.error("Verify Aadhaar OTP error:", err);
      setIsAadharVerified(false);
      setOtpSent(true);
      const errMsg =
        err.response?.data?.data?.data?.message ||

        "Invalid OTP. Please try again.";
      setOtpMessage(errMsg);
      responsiveToast(errMsg, "error");
    } finally {
      setVerifyingOtp(false);
      dispatch(getLoaderAction2(false));
    }
  };

  const handleFileInputChange = (name, event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setSelectedImageEvent(event);
    setCropperTargetName(name);
    setCropperOpen(true);
  };

  const getCroppedImg = (imageRef, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) return;
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });

        setCropperOpen(false);
        handleImageChange(cropperTargetName, croppedFile);
        resolve(croppedFile);
      }, "image/jpeg");
    });
  };

  const handleImageChange = async (name, file) => {
    if (!file || file.size > 10 * 1024 * 1024) return;

    if (images[name]?.url) {
      URL.revokeObjectURL(images[name].url);
    }

    const localUrl = URL.createObjectURL(file);

    dispatch(
      setBasicImage({
        name,
        image: {
          name: file.name,
          url: localUrl,
          s3Url: "",
          file: file,
        },
      }),
    );

    clearError(name);

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));
    try {
      const folderName = name === "aadhaarFront" ? "aadharfront" : "user_image";
      const randomNumber = Math.floor(Math.random() * 10000000000);
      const fileExt = file.name.split(".").pop() || "jpg";
      const formattedFilename = `onboarding/${folderName}/image_cropper_${randomNumber}.${fileExt}`;

      const presignedReqData = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type || "image/jpeg",
          },
        ],
      };

      const presignedRes = await axios.post(PresentUrl, presignedReqData, { headers });
      const uploadedUrls = presignedRes.data?.data || presignedRes.data;

      let s3CleanUrl = "";
      if (Array.isArray(uploadedUrls) && uploadedUrls.length > 0) {
        const presignedPutUrl = uploadedUrls[0];
        s3CleanUrl = String(presignedPutUrl).split("?")[0];

        await fetch(presignedPutUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type || "image/jpeg",
            "x-amz-acl": "public-read",
          },
          body: file,
        });
      }

      const finalS3Url = s3CleanUrl || localUrl;

      dispatch(
        setBasicImage({
          name,
          image: {
            name: file.name,
            url: finalS3Url,
            s3Url: finalS3Url,
            file: file,
          },
        }),
      );

      if (name === "aadhaarFront") {
        const currentFrontCount = Number(form.aadhar_front_count || 0);
        dispatch(updateBasicField({ name: "aadhar_front_count", value: currentFrontCount + 1 }));

        try {
          const formData = new FormData();
          formData.append("aadhar_card", file);
          const ocrRes = await axios.post(denaveAadharFetchApi, formData, { headers });
          const extracted =
            ocrRes.data?.data?.extracted_data || ocrRes.data?.extracted_data || ocrRes.data?.data || ocrRes.data;

          if (extracted) {
            extractedOcrDataRef.current = extracted;

            if (extracted.aadhar_id || extracted.aadhar_number) {
              dispatch(
                updateBasicField({
                  name: "aadhar_number",
                  value: String(extracted.aadhar_id || extracted.aadhar_number).replace(/\s/g, ""),
                }),
              );
            }

            if (verificationMode === "Manual") {
              if (extracted.name || extracted.first_name) {
                dispatch(
                  updateBasicField({ name: "first_name", value: extracted.name || extracted.first_name }),
                );
              }
              if (extracted.dob || extracted.date_of_birth) {
                dispatch(
                  updateBasicField({ name: "DateofBirth", value: formatDateOfBirth(extracted.dob || extracted.date_of_birth) }),
                );
              }
              if (extracted.gender) {
                dispatch(
                  updateBasicField({ name: "gender", value: formatGender(extracted.gender) }),
                );
              }
              if (extracted.address || extracted.district || extracted.state || extracted.place_of_birth) {
                dispatch(
                  updateBasicField({
                    name: "placeofBirth",
                    value:
                      extracted.place_of_birth ||
                      extracted.address ||
                      extracted.district ||
                      extracted.state ||
                      "",
                  }),
                );
              }
            }
          }
        } catch (ocrErr) {
          console.error("Aadhaar OCR detail fetch error:", ocrErr);
        }
      }
    } catch (err) {
      console.error("Presigned URL upload error:", err);
    } finally {
      dispatch(getLoaderAction2(false));
    }
  };

  const removeImage = (name) => {
    if (images[name]?.url) {
      URL.revokeObjectURL(images[name].url);
    }

    dispatch(removeBasicImage(name));

    if (name === "aadhaarFront") {
      dispatch(updateBasicField({ name: "aadhar_number", value: "" }));
      dispatch(updateBasicField({ name: "first_name", value: "" }));
      dispatch(updateBasicField({ name: "DateofBirth", value: "" }));
      dispatch(updateBasicField({ name: "gender", value: "" }));
      dispatch(updateBasicField({ name: "placeofBirth", value: "" }));
      setInitialFields((prev) => ({
        ...prev,
        aadhar_number: false,
        first_name: false,
        gender: false,
      }));
      setIsAadharVerified(false);
      setOtpSent(false);
      setOtpValue("");
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpMessage("");
    }
  };

  const getMissingFields = useCallback(() => {
    const missingObjects = requiredFields.filter((field) => {
      const value = form[field.name] || "";

      if (field.name === "aadhar_number") {
        return value.length !== 12;
      }

      if (
        field.name === "phoneNum" ||
        field.name === "emergency_contact_number"
      ) {
        return value.length !== 10;
      }

      if (field.name === "DateofBirth") {
        return !isValidDateOfBirth(value);
      }

      return !value || value === "Select";
    });

    if (!form.gender || form.gender === "Select") {
      missingObjects.push({ name: "gender", label: "Gender" });
    }

    const missingNames = new Set(missingObjects.map((field) => field.name));

    if (!images.aadhaarFront) missingNames.add("aadhaarFront");
    if (!images.profile) missingNames.add("profile");

    setErrorFields(missingNames);

    const missingLabels = missingObjects.map((field) => field.label);

    if (!images.aadhaarFront) missingLabels.push("Aadhaar Front image");
    if (!images.profile) missingLabels.push("Profile image");

    const details = selfonboardData || employeeDetails;
    const isPutMethod = Boolean(
      details?.employeetimeline_id?.basic_info ||
      details?.employeetimeline_id?.basic_details ||
      details?.employeetimeline_id?.basic_info_form ||
      details?.basicform_id ||
      details?.basic_form_id ||
      details?.basicform ||
      details?.basic_form ||
      details?.basic_info_id ||
      details?.basic_info ||
      fetchedBasicFormIdRef.current
    );

    const isVerified =
      isAadharVerified ||
      form.is_aadhar_verified ||
      form.aadhar_verified;

    // Require OTP verification only for POST method (new record creation) and when not verified
    if (!isPutMethod && verificationMode === "UIDAI" && !isVerified) {
      missingLabels.push("Aadhaar Verification (Please verify Aadhaar OTP)");
    }

    return missingLabels;
  }, [form, images, verificationMode, isAadharVerified, selfonboardData, employeeDetails]);

  useImperativeHandle(
    ref,
    () => ({
      getMissingFields,
      isComplete: () => getMissingFields().length === 0,
    }),
    [getMissingFields],
  );

  const renderUpload = (name, label) => {
    const image = images[name];
    const hasError = errorFields.has(name);

    console.log("basicinformation", form);

    return (
      <div className={styles.uploadBlock}>
        <label className={styles.label}>
          {label}
          <span>*</span>
        </label>

        <div className={styles.previewRow}>
          {image ? (
            <>
              <img
                className={styles.imagePreview}
                src={image.url}
                alt={`${label} preview`}
              />
              <button
                className={styles.removeButton}
                type="button"
                onClick={() => removeImage(name)}
              >
                Remove Image
              </button>
            </>
          ) : (
            <label className={styles.uploadButton}>
              Upload Image
              <input
                className={styles.hiddenInput}
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                onChange={(event) => handleFileInputChange(name, event)}
              />
            </label>
          )}
        </div>

        {hasError && (
          <p className={styles.fieldError}>Please upload this image</p>
        )}
      </div>
    );
  };

  return (
    <div className={styles.basicInformation}>
      <header className={styles.sectionHeader}>Basic Information</header>

      <div className={styles.content}>
        <p className={styles.note}>
          Note: Upload the pictures. Verify that the file is in JPG, JPEG, or
          PNG format and that its size is less than 10 MB.
        </p>

        <div className={styles.verifyActions}>
          <button
            type="button"
            className={
              verificationMode === "UIDAI"
                ? styles.activeButton
                : styles.outlineButton
            }
            onClick={() => setVerificationMode("UIDAI")}
          >
            UIDAI Verification
          </button>
          <button
            type="button"
            className={
              verificationMode === "Manual"
                ? styles.activeButton
                : styles.outlineButton
            }
            onClick={() => {
              setVerificationMode("Manual");
              const extracted = extractedOcrDataRef.current;
              if (extracted) {
                if (extracted.name || extracted.first_name) {
                  dispatch(
                    updateBasicField({
                      name: "first_name",
                      value: extracted.name || extracted.first_name,
                    })
                  );
                }
                if (extracted.dob || extracted.date_of_birth) {
                  dispatch(
                    updateBasicField({
                      name: "DateofBirth",
                      value: extracted.dob || extracted.date_of_birth,
                    })
                  );
                }
                if (extracted.gender) {
                  dispatch(
                    updateBasicField({
                      name: "gender",
                      value: formatGender(extracted.gender),
                    })
                  );
                }
                if (
                  extracted.address ||
                  extracted.district ||
                  extracted.state ||
                  extracted.place_of_birth
                ) {
                  dispatch(
                    updateBasicField({
                      name: "placeofBirth",
                      value:
                        extracted.place_of_birth ||
                        extracted.address ||
                        extracted.district ||
                        extracted.state ||
                        "",
                    })
                  );
                }
              }
            }}
          >
            Manual Verification
          </button>
        </div>

        <div className={styles.uploadGrid}>
          {renderUpload("aadhaarFront", "Aadhaar Front image")}
          {renderUpload("profile", "Profile")}
        </div>

        <div className={styles.aadhaarNumber}>
          <label className={styles.label}>
            Aadhaar Number<span>*</span>
            {isAadharVerified && (
              <span
                style={{
                  color: "#16a34a",
                  fontSize: "14px",
                  marginLeft: "12px",
                  fontWeight: "600",
                }}
              >
                ✓ Verified
              </span>
            )}
          </label>
          <div style={{ display: "flex", gap: "12px", alignItems: "center", width: "100%" }}>
            <input
              style={{ flex: 1, minWidth: "200px" }}
              value={form.aadhar_number || ""}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={12}
              disabled={Boolean(initialFields.aadhar_number)}
              className={
                errorFields.has("aadhar_number") ? styles.inputError : ""
              }
              onChange={(event) =>
                updateNumberField("aadhar_number", event.target.value)
              }
            />

            {verificationMode === "UIDAI" && isAadharVerified && (
              <span className={styles.verifiedBadge}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#047857"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Verified
              </span>
            )}

            {verificationMode === "UIDAI" && !isAadharVerified && (
              <button
                type="button"
                className={styles.uploadButton}
                disabled={
                  sendingOtp ||
                  !form.aadhar_number ||
                  form.aadhar_number.length !== 12
                }
                style={{
                  minWidth: "110px",
                  opacity:
                    sendingOtp ||
                      !form.aadhar_number ||
                      form.aadhar_number.length !== 12
                      ? 0.6
                      : 1,
                }}
                onClick={handleSendAadhaarOtp}
              >
                {sendingOtp
                  ? "Sending..."
                  : otpSent
                    ? "Resend OTP"
                    : "Send OTP"}
              </button>
            )}
          </div>

          {errorFields.has("aadhar_number") && (
            <p className={styles.fieldError}>
              Please enter a valid 12-digit Aadhaar number
            </p>
          )}
        </div>

        {verificationMode === "UIDAI" && otpSent && !isAadharVerified && (
          <div style={{ marginTop: "16px", marginBottom: "16px" }}>
            <label className={styles.label}>
              Enter OTP<span>*</span>
            </label>
            <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
              <div style={{ display: "flex", gap: "8px" }}>
                {otpDigits.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpDigitChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    style={{
                      width: "40px",
                      height: "44px",
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "600",
                      borderRadius: "4px",
                      border: "1px solid #cbd5e1",
                    }}
                  />
                ))}
              </div>
              <button
                type="button"
                className={styles.uploadButton}
                disabled={verifyingOtp || otpValue.length < 4}
                style={{
                  minWidth: "110px",
                  opacity: verifyingOtp || otpValue.length < 4 ? 0.6 : 1,
                }}
                onClick={handleVerifyAadhaarOtp}
              >
                {verifyingOtp ? "Verifying..." : "Submit OTP"}
              </button>
            </div>
          </div>
        )}

        {otpMessage && (
          <p
            style={{
              color:
                isAadharVerified ||
                  (otpMessage.toLowerCase().includes("sent") && !otpMessage.toLowerCase().includes("invalid")) ||
                  (otpMessage.toLowerCase().includes("success") && !otpMessage.toLowerCase().includes("invalid"))
                  ? "#16a34a"
                  : "#ef4d39",
              fontSize: "14px",
              marginTop: "6px",
              fontWeight: "500",
            }}
          >
            {otpMessage}
          </p>
        )}

        <div className={styles.formGrid}>
          {inputFields.slice(0, 4).map((field) => (
            <label className={styles.field} key={field.name}>
              <span>
                {field.label}
                {field.required ? <b>*</b> : null}
              </span>

              <input
                type={field.type || "text"}
                value={form[field.name] || ""}
                disabled={Boolean(initialFields[field.name])}
                inputMode={
                  field.name === "phoneNum" ||
                    field.name === "emergency_contact_number"
                    ? "numeric"
                    : undefined
                }
                pattern={
                  field.name === "phoneNum" ||
                    field.name === "emergency_contact_number"
                    ? "[0-9]*"
                    : undefined
                }
                maxLength={
                  field.name === "phoneNum" ||
                    field.name === "emergency_contact_number"
                    ? 10
                    : undefined
                }
                className={errorFields.has(field.name) ? styles.inputError : ""}
                onChange={(event) => {
                  if (
                    field.name === "phoneNum" ||
                    field.name === "emergency_contact_number"
                  ) {
                    updateNumberField(field.name, event.target.value);
                  } else {
                    updateField(field.name, event.target.value);
                  }
                }}
              />

              {errorFields.has(field.name) && (
                <p className={styles.fieldError}>
                  {field.name === "phoneNum" ||
                    field.name === "emergency_contact_number"
                    ? "Please enter a valid 10-digit number"
                    : field.name === "DateofBirth"
                    ? "Please enter a valid Date of Birth"
                    : "Please fill this field"}
                </p>
              )}
            </label>
          ))}

          <fieldset className={styles.genderField}>
            <legend>
              Gender<b>*</b>
            </legend>

            {["Male", "Female", "Other"].map((genderVal) => (
              <label key={genderVal}>
                <input
                  type="radio"
                  name="gender"
                  disabled={Boolean(initialFields.gender)}
                  checked={
                    String(form.gender || "").toLowerCase() === genderVal.toLowerCase() ||
                    formatGender(form.gender) === genderVal
                  }
                  onChange={() => updateField("gender", genderVal)}
                />
                {genderVal}
              </label>
            ))}
          </fieldset>

          {inputFields.slice(4).map((field) => (
            <label className={styles.field} key={field.name}>
              <span>
                {field.label}
                {field.required ? <b>*</b> : null}
              </span>

              <input
                type={field.type || "text"}
                value={form[field.name] || ""}
                className={errorFields.has(field.name) ? styles.inputError : ""}
                onChange={(event) =>
                  updateField(field.name, event.target.value)
                }
              />

              {errorFields.has(field.name) && (
                <p className={styles.fieldError}>Please fill this field</p>
              )}
            </label>
          ))}

          <label className={styles.field}>
            <span>
              Blood Group<b>*</b>
            </span>
            <select
              value={formatBloodGroup(form.blood_group) || "Select"}
              className={
                errorFields.has("blood_group") ? styles.inputError : ""
              }
              onChange={(event) =>
                updateField("blood_group", event.target.value)
              }
            >
              {selectOptions.bloodGroup.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
              {form.blood_group &&
                form.blood_group !== "Select" &&
                !selectOptions.bloodGroup.includes(formatBloodGroup(form.blood_group)) && (
                  <option value={form.blood_group}>{form.blood_group}</option>
                )}
            </select>
            {errorFields.has("blood_group") && (
              <p className={styles.fieldError}>Please select a blood group</p>
            )}
          </label>

          <label className={styles.field}>
            <span>
              Religion<b>*</b>
            </span>
            <select
              value={form.religion || "Select"}
              className={errorFields.has("religion") ? styles.inputError : ""}
              onChange={(event) => updateField("religion", event.target.value)}
            >
              {selectOptions.religion.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {errorFields.has("religion") && (
              <p className={styles.fieldError}>Please select a religion</p>
            )}
          </label>

          <label className={styles.field}>
            <span>Personal Identification Mark</span>
            <input
              value={form.personal_identification_mark || ""}
              onChange={(event) =>
                updateField("personal_identification_mark", event.target.value)
              }
            />
          </label>


          {/*
          <label className={styles.field}>
            <span>
              Employement Type<b>*</b>
            </span>
            <select
              value={
                form.employee_type === "Permanent"
                  ? "0"
                  : form.employee_type === "Contractual"
                    ? "1"
                    : form.employee_type === "Consultant"
                      ? "2"
                      : form.employee_type === "Freelancer"
                        ? "3"
                        : form.employee_type === "Intern"
                          ? "4"
                          : form.employee_type === "Apprentice"
                            ? "5"
                            : form.employee_type || ""
              }
              className={
                errorFields.has("employee_type") ? styles.inputError : ""
              }
              onChange={(event) =>
                updateField("employee_type", event.target.value)
              }
            >
              {selectOptions.employmentType.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errorFields.has("employee_type") && (
              <p className={styles.fieldError}>
                Please select an employment type
              </p>
            )}
          </label>

          <label className={styles.field}>
            <span>
              Employee Catergory<b>*</b>
            </span>
            <select
              value={
                form.employee_category === "FOS"
                  ? "0"
                  : form.employee_category === "Non FOS"
                    ? "1"
                    : form.employee_category === "Non FOS - Tele"
                      ? "2"
                      : form.employee_category === "Apprentice"
                        ? "3"
                        : form.employee_category || ""
              }
              className={
                errorFields.has("employee_category") ? styles.inputError : ""
              }
              onChange={(event) =>
                updateField("employee_category", event.target.value)
              }
            >
              {selectOptions.employeeCategory.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errorFields.has("employee_category") && (
              <p className={styles.fieldError}>
                Please select an employee category
              </p>
            )}
          </label>

          <label className={styles.field}>
            <span>
              State<b>*</b>
            </span>
            <select
              value={form.state || "Select"}
              className={errorFields.has("state") ? styles.inputError : ""}
              onChange={(event) => {
                updateField("state", event.target.value);
                updateField("city", "");
              }}
            >
              <option value="Select">Select State</option>
              {denaveStateList.map((st) => (
                <option key={st} value={st}>
                  {st}
                </option>
              ))}
              {form.state && form.state !== "Select" && !denaveStateList.includes(form.state) && (
                <option value={form.state}>{form.state}</option>
              )}
            </select>
            {errorFields.has("state") && (
              <p className={styles.fieldError}>Please select a state</p>
            )}
          </label>

          <label className={styles.field}>
            <span>
              City<b>*</b>
            </span>
            <select
              value={form.city || "Select"}
              className={errorFields.has("city") ? styles.inputError : ""}
              onChange={(event) => updateField("city", event.target.value)}
            >
              <option value="Select">Select City</option>
              {denaveCityList.map((ct) => (
                <option key={ct} value={ct}>
                  {ct}
                </option>
              ))}
              {form.city && form.city !== "Select" && !denaveCityList.includes(form.city) && (
                <option value={form.city}>{form.city}</option>
              )}
            </select>
            {errorFields.has("city") && (
              <p className={styles.fieldError}>Please select a city</p>
            )}
          </label>

          <label className={styles.field}>
            <span>Referral Number</span>
            <input
              value={form.referral_number || ""}
              onChange={(event) =>
                updateField("referral_number", event.target.value)
              }
            />
          </label>
          */}

        </div>
      </div>

      {cropperOpen && (
        <ImageCropper
          updateAvatar={() => { }}
          selectedImage={selectedImageEvent}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCropperOpen(false)}
        />
      )}
    </div>
  );
});

export default BasicInformation;
